import { Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import Text from "src/components/Text";

import { styles } from './styles';

interface MessagePageProps {
    title: string;
    message?: string;
    buttonText: string;
    buttonTo: string;
    imageSrc?: string;
}

const MessagePage = ({ title, message, buttonText, buttonTo, imageSrc } : MessagePageProps) => {
  const navigate = useNavigate();
  const { classes } = styles();

  return (
    <div className={classes.main}>
        {imageSrc && <img src={imageSrc} alt="Página de redirección" width="100"/>}
        <Text textAlign="center" className={classes.text}>{title}</Text>
        {message && <p>{message}</p>}
        <Button
            color="primary"
            variant="contained"
            onClick={() => navigate(buttonTo)}
            className={classes.button}
        >
            {buttonText}
        </Button>
    </div>
  );
};

export default MessagePage;
